import { SHORTLINKS_MIN_VALUE } from 'modules/projectSettings/constants';
import { createContext, useContext } from 'react';
import noop, { NoOp } from 'utils/noop';
import { DEFAULT_LINK_SHORTENING_TRACKING_DOMAIN } from '../constants';

export interface SMSLinkShorteningContextState {
  isSMSLinkShorteningEnabled: boolean;
  localStorageDomain: string;
  resetIsSMSLinkShorteningEnabled: NoOp;
  setIsSMSLinkShorteningEnabled: NoOp;
  setLocalStorageDomain: (newDomains: string[]) => void;
  shortlinkLength: number;
  defaultSmsLinkShorteningDomain: string;
}

export const SMSLinkShorteningContext = createContext<SMSLinkShorteningContextState>({
  isSMSLinkShorteningEnabled: false,
  localStorageDomain: '',
  resetIsSMSLinkShorteningEnabled: noop,
  setIsSMSLinkShorteningEnabled: noop,
  setLocalStorageDomain: noop,
  shortlinkLength: SHORTLINKS_MIN_VALUE,
  defaultSmsLinkShorteningDomain: DEFAULT_LINK_SHORTENING_TRACKING_DOMAIN,
});

export const useSMSLinkShortening = () => useContext(SMSLinkShorteningContext);
